/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { all, any } from 'cio/app-models/conditions/group';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import ObjectAttributeCondition from 'cio/app-models/conditions/object-attribute';

interface CioConditionEditorRelationshipDataFilterArgs {
  condition: RelationshipCondition;
  depth: number;
  filterOperator: 'and' | 'or';
  filters: ObjectAttributeCondition[];
  showButton: boolean;
  onAddFilter: () => unknown;
  onRemove: (filter: ObjectAttributeCondition) => unknown;
  disabled: boolean;
}

export default class CioConditionEditorRelationshipDataFilter extends Component<CioConditionEditorRelationshipDataFilterArgs> {
  get groupTypes() {
    return [
      { value: all, label: 'all' },
      { value: any, label: 'at least one' },
    ];
  }

  get showButton() {
    return this.args.showButton ?? true;
  }

  get depth() {
    return this.args.depth ?? 0;
  }

  get depthClassModifier() {
    return `${this.depth % 2 === 0 ? 'even' : 'odd'}`;
  }
}
